const GENERIC_ERROR_MESSAGE = "An unexpected error occurred. Please try again later.";
const MAX_USER_MESSAGE_LENGTH = 300;

import { GraphQLErrorEnvelope } from "./graphql-error-envelope";

export function extractGraphQLErrorInfo(error: unknown): { userMessage: string; technicalDetail: string } {
  if (!error || typeof error !== "object") {
    return { userMessage: GENERIC_ERROR_MESSAGE, technicalDetail: String(error) };
  }

  const graphqlError = error as GraphQLErrorEnvelope;

  const firstErrorMessage = graphqlError.response?.errors?.[0]?.message;
  let userMessage: string;

  if (firstErrorMessage && firstErrorMessage.length > 0) {
    userMessage =
      firstErrorMessage.length > MAX_USER_MESSAGE_LENGTH
        ? firstErrorMessage.slice(0, MAX_USER_MESSAGE_LENGTH) + "..."
        : firstErrorMessage;
  } else {
    userMessage = GENERIC_ERROR_MESSAGE;
  }

  const sensitiveKeySet = new Set(["request", "headers", "authorization"]);
  const seenSet = new Set<unknown>();
  const redactSensitiveFields = (key: string, value: unknown) => {
    if (sensitiveKeySet.has(key.toLowerCase())) return undefined;
    if (typeof value === "object" && value !== null) {
      if (seenSet.has(value)) return "[Circular]";
      seenSet.add(value);
    }
    return value;
  };

  const safeStringify = (value: unknown): string => {
    try {
      return JSON.stringify(value, redactSensitiveFields, 2);
    } catch {
      return String(value);
    }
  };

  let technicalDetail: string;
  if (graphqlError.response) {
    const { errors, status } = graphqlError.response;
    technicalDetail = safeStringify({ errors, status });
  } else if (graphqlError.message) {
    technicalDetail = graphqlError.message;
  } else {
    technicalDetail = safeStringify(error);
  }

  return { userMessage, technicalDetail };
}
